export var UsageTitleBarText = "Usage";
export var UsageMainPage_Refresh = "Refresh";
export var UsageMainPage_Export = "Save";
export var UsageMainPage_Help = "Help";
export var UsageDataContainer_NoItems = "No data";
export var UsageDataContainer_NoItemsAndDataMayBeDelayed = "No data (usage records may be delayed up to ten minutes)";
export var UsageDataContainer_Loading = "Loading...";
export var Column_User = "User";
export var Column_UserAgent = "User agent";
export var Column_IPAddress = "IP address";
export var Column_TimeRange = "Time range";
export var Column_Service = "Service";
export var Column_Application = "Application";
export var Column_Command = "Command";
export var Column_UriStem = "UriStem";
export var Column_Referrer = "Referrer";
export var Column_Status = "Status";
export var Column_Count = "Count";
export var Column_UsageTSTUs = "Usage (TSTUs)";
export var Column_Delay = "Delay (s)";
export var Column_Feature = "Feature";
export var Column_Definition = "Definition";
export var Column_Instance = "Instance";
export var Column_UserTooltip_NOTUSED = "The user whose requests are displayed";
export var Column_UserAgentTooltip_NOTUSED = "The user agent string for the request(s)";
export var Column_IPAddressTooltip_NOTUSED = "The IP address for the request(s)";
export var Column_TimeRangeTooltip_NOTUSED = "The beginning of the time window for the request(s)";
export var Column_ApplicationTooltip_NOTUSED = "The high level area (WorkItem Tracking, Version Control, etc.) of the request(s)";
export var Column_CommandTooltip_NOTUSED = "The specific command of the request(s)";
export var Column_CountTooltip_NOTUSED = "The number of requests included in the row";
export var Column_UsageTSTUsTooltip_NOTUSED = "The Team Services Throughput Units (TSTUs), a measure of load, consumed by the request(s)";
export var Column_DelayTooltip_NOTUSED = "The total amount of time the request(s) were delayed, in seconds";
export var UsageMainPage_RefreshTooltip = "Refresh the displayed usage";
export var UsageMainPage_ExportTooltip = "Download to csv";
export var UsageMainPage_HelpTooltip = "Review the Team Services usage and rate limiting documentation";
export var FilterContainer_User = "User";
export var ColumnFilter_Columns = "Column options";
export var FilterContainer_ClearFilters = "Reset filters";
export var FilterContainer_Keywords = "Filter by keywords";
export var FilterContainer_Services = "Services";
export var FilterContainer_Status = "Status";
export var FilterContainer_TimeRange = "Time range";
export var FilterContainer_UsageTSTUs = "TSTU minimum";
export var FilterContainer_Definition = "Project/Definition";
export var TextFieldContainer_Invalid = "Invalid numeric value specified.";
export var TimeRangePicker_BinInterval = "Bin interval";
export var Status_All = "All statuses";
export var Status_Blocked = "Blocked";
export var Status_Delayed = "Delayed";
export var Status_Normal = "Normal";
export var UsageDataContainer_NumberOfRecords = "Showing {0} results";
export var UsageDataContainer_ColumnSortedAscendingAnnouncment = "{0} column sorted ascending";
export var UsageDataContainer_ColumnSortedDescendingAnnouncment = "{0} column sorted descending";
export var Pivot_Browse = "Usage By User";
export var Pivot_BrowseTooltip = "Browse all data by adjusting the filters";
export var Pivot_TopCommands = "Top commands";
export var Pivot_ByPipeline = "Usage By Pipeline";
export var Pivot_ByPipelineToolTip = "Set filters to show build and release pipelines";
export var Pivot_TopBuildPipelines = "Top Build Pipelines";
export var Pivot_TopBuildPipelinesToolTip = "Set filters to show top build pipelines";
export var Pivot_TopReleasePipelines = "Top Release Pipelines";
export var Pivot_TopReleasePipelinesToolTip = "Set filters to show top release pipelines";
export var Pivot_TopCommandsTooltip = "Set filters to show the top commands";
export var Pivot_TopUserAgents = "Top user agents";
export var Pivot_TopUserAgentsTooltip = "Set filters to show the top user agents";
export var Pivot_TopUsers = "Top users";
export var Pivot_TopUsersTooltip = "Set filters to show the top users";
export var QueryDate_Custom = "Custom";
export var QueryDate_Last24Hours = "Last 24 hours";
export var QueryDate_Last28Days = "Last 28 days";
export var QueryDate_Last4Hours = "Last 4 hours";
export var QueryDate_Last7Days = "Last 7 days";
export var QueryDate_LastHour = "Last hour";
export var TimeBin_300 = "5 minutes";
export var TimeBin_3600 = "1 hour";
export var Warning_MaximumRecordsReturned = "The maximum number of records ({0}) was returned. Adjust the query criteria to narrow the scope of the query.";
export var IdentityPicker_Placeholder = "User";
export var UsageDataContainer_NumberOfRecordsSingular = "Showing {0} result";
export var UsageMainPage_Dismiss = "Dismiss this message";
export var FilterContainer_KeywordsTooltip = "Keywords apply to IP address, user agent, application and command.";
export var Status_Concurrent = "Concurrent Requests";
export var Status_ConcurrentTimeout = "Concurrent Requests Queue Timeout";
export var Status_Long = "Long Term Consumption";
export var Status_Short = "Short Term Consumption";
